import { VSF } from '@vue-storefront/core/lib/module'
import loadForter from '../vendor'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

function isForterManagedCookie(value: string) {
  return typeof value === 'string' && value.indexOf('_32ck__tt') !== -1
}

export function afterRegistration({ Vue, isServer }: VSF): void {
  if (isServer) {
    return
  }
  const forterSiteID =
    typeof currentStoreView === 'function'
      ? currentStoreView().forterSiteID
      : null
  if (!forterSiteID || window['ftr__config']) {
    return
  }
  document.addEventListener('ftr:tokenReady', (evt: CustomEvent) => {
    const token = evt.detail
    const cookieName = 'forterToken'
    if (typeof token !== 'string' || !token.length) {
      return
    }
    const currentCookieValue = Vue.prototype.$cookies.get(cookieName)
    if (currentCookieValue === null) {
      Vue.prototype.$cookies.set(cookieName, token, 1, '/')
      return
    }
    if (isForterManagedCookie(currentCookieValue)) {
      return
    }
    if (currentCookieValue === token) {
      return
    }
    Vue.prototype.$cookies.set(cookieName, token, 1, '/')
  })
  loadForter(forterSiteID)
}
